/**
 * Query keys for DoseSpot Prior Authorization data.
 *
 * Mirrors the ``rxKeys`` layout under ``entities/rx`` — scoped by patient
 * user id for listings and by record id (our internal UUID) for single-case
 * detail views.
 */
export const priorAuthKeys = {
  all: ['priorAuth'] as const,

  patientList: (patientUserId: string) => ['priorAuth', 'patient', patientUserId, 'list'] as const,

  details: (recordId: string) => ['priorAuth', 'details', recordId] as const,
};
